<div *ngIf="errorMessage != null">
  <span class="sr-only">(error)</span>
  <small class="form-color-alert wBody10" role="alert">{{ errorMessage }}</small>
</div>